package com.devi3east.bashbuddy.search.ui.components

import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable

@Composable
fun DistanceFilterSheet(
    onApply: (Int) -> Unit,
    onDismiss: () -> Unit
) {

    val distances = listOf(
        25, 50, 75, 100, 125, 150, 175, 200
    )

    FilterBottomSheet(
        title = "Distance in Miles",
        onDismiss = onDismiss
    ) {
        distances.forEach { distance ->
            TextButton(
                onClick = { onApply(distance) }
            ) {
                Text("$distance miles")
            }
        }
    }
}